const pathNames = {
  index: '/',
  home: '/home',
  environment: '/environment',
  operations: '/operations',
  maintenance: '/maintenance',
};

export default pathNames;
